import React from "react";
import {t} from "../../../../dev/helpers/translator";
import Market from "../market";
import Loader from "../loader";
import Helpers from "../../../helpers/helperFunctions";
import Config from "../../../config/main";
import KeyboardInput from "../InputKeyboard";

export default function marketsListTemplate () {
    let {selectorKey, marketsNames, game, favoritesMarketsNames, boostedOddsGameIds} = this.props;

    if (marketsNames && marketsNames.length && game) {
        favoritesMarketsNames.forEach((favMarketName) => {
            marketsNames.map((marketName) => {
                marketName.marketName === favMarketName ? marketName.order = 0 : marketName.order;
            });
            Helpers.moveElementArrayFirstIndex(marketsNames, 0, marketsNames.indexOf(favMarketName));
        });
        if (Config.sportListThatCanBeBoostedOdds.includes(game.alias)) {
            const boostedGameIds = Config.enableBoostedOdds && Object.keys(boostedOddsGameIds).includes(game.id.toString()) && boostedOddsGameIds[game.id];
            var boostedGameMarketsObject = boostedGameIds && createDynamicObjectFromGameMarketsArray(boostedGameIds);
        }
        return <div className="markets-list-wrapper">
            <div className="market-group-title-m">
                <h3>{t("Markets")}</h3>
                {
                    Config.enableMarketSearch &&
                    <div className='market-search'>
                        <KeyboardInput type="text" placeholder={t(`Type market name...`)} onChange={(e) => this.handleChange(e, marketsNames)}
                            enableClearButton={true} clearSearchFiled={this.clearSearchFiled}
                        />
                    </div>
                }
            </div>
            <div className="all-markets-view-m">
                {
                    !this.state.filtered || this.state.filtered.length === 0 ? marketsNames.sort((a, b) => a.order - b.order).map(({ marketName }, index) => {
                        return <Market key={marketName}
                            index={index}
                            marketName={marketName}
                            selectorKey={selectorKey}
                            game={game}
                            boostedOdds={boostedGameMarketsObject}/>;
                    })
                        : this.state.filtered && this.state.filtered.length > 0 && this.state.filtered.sort((a, b) => a.order - b.order).map(({ marketName }, index) => {
                            return <Market key={marketName}
                                index={index}
                                marketName={marketName}
                                selectorKey={selectorKey}
                                game={game}
                                boostedOdds={boostedGameMarketsObject}/>;
                        })
                }
            </div>
            {
                this.props.game.is_live === 1 && <div className="singe-market-view-m">
                    <p className="indicator-text">{t(`The time display shown within live betting serves as an indicator. The company takes no responsibility for the correctness and currentness of the displayed information like score or time`)}.</p>
                </div>
            }
        </div>;
    } else {
        if (marketsNames && !marketsNames.length) {
            return <div className="all-markets-view-m">
                <p className='not-accepting-bets'>{t("We're not accepting bets on this event at the moment.")}</p></div>;
        } else {
            return <Loader/>;
        }
    }
}

function createDynamicObjectFromGameMarketsArray (array) {
    let newObject = {};
    if (array) {
        for (let item of array) {
            var tempObj = {
                ...tempObj,
                [item.Id]: {
                    Id: item.Id,
                    marketId: item.MarketId,
                    name: item.Name,
                    marketName: item.MarketName,
                    MatchId: item.MatchId
                }
            };
            newObject = tempObj;
        }
    }
    return newObject;
}